// extracted by mini-css-extract-plugin
export default {"tags":"style_tags__BF-wP","tags__item":"style_tags__item__0+61N"};